import { Controller } from "@hotwired/stimulus"

// data-controller="table-break-spaces"
export default class extends Controller {
  connect() {
    if (window.innerWidth <= 1024) {
      document.querySelectorAll('td').forEach(td => {
        if (td.offsetWidth > 379) {
          td.classList.add('break-spaces');
        }
      });
    }
  }
}